import(/* webpackMode: "eager", webpackExports: ["Analytics"] */ "/vercel/path0/node_modules/@vercel/analytics/dist/react/index.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["SpeedInsights"] */ "/vercel/path0/node_modules/@vercel/speed-insights/dist/next/index.mjs");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/font/local/target.css?{\"path\":\"src/app/layout.js\",\"import\":\"\",\"arguments\":[{\"src\":\"./fonts/ProximaNova-Regular.woff\",\"variable\":\"Proxima-Regular\",\"weight\":\"100 500\"}],\"variableName\":\"ProximaRegular\"}");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/font/local/target.css?{\"path\":\"src/app/layout.js\",\"import\":\"\",\"arguments\":[{\"src\":\"./fonts/ProximaNova-Bold.woff\",\"variable\":\"Proxima-Bold\",\"weight\":\"100 500\"}],\"variableName\":\"ProximaBold\"}");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/components/client-only-components.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/components/layout/footer.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/components/layout/navbar.jsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/components/seo/seo-head.jsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/components/seo/seo-manager.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeProvider"] */ "/vercel/path0/src/app/components/theme-provider.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["LanguageProvider"] */ "/vercel/path0/src/app/context/language-context.jsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/globals.scss");
